import { render, staticRenderFns } from "./TenantEditPayments.vue?vue&type=template&id=17c25bca&"
import script from "./TenantEditPayments.vue?vue&type=script&lang=js&"
export * from "./TenantEditPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports